import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { History as HistoryIcon } from "lucide-react";

export default function AdminWarehouseHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/admin/warehouse-history")
      .then(r => setRows(r.data))
      .catch(e => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="admin-wh-history-page" className="space-y-5">
      <div>
        <div className="text-xs font-mono-tech uppercase tracking-[0.2em] text-cyan-400 mb-1">/ Warehouse</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Warehouse Activity</h1>
      </div>
      {loading ? <div className="py-14 text-center text-slate-500">Loading…</div> :
       rows.length === 0 ? (
        <div className="border border-dashed border-slate-200 dark:border-slate-800 rounded-lg py-14 text-center bg-slate-100/30 dark:bg-slate-900/30 text-slate-500">
          <HistoryIcon className="w-10 h-10 text-slate-700 mx-auto mb-3" /> No activity.
        </div>
       ) : (
        <div className="border border-slate-200 dark:border-slate-800 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-100/60 dark:bg-slate-900/60 text-[11px] font-mono-tech uppercase tracking-wider text-slate-500">
              <tr>
                <th className="text-left px-4 py-3">When</th>
                <th className="text-left px-4 py-3">Action</th>
                <th className="text-left px-4 py-3">Package</th>
                <th className="text-left px-4 py-3">Batch</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="text-left px-4 py-3">By</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {rows.map(h => (
                <tr key={h.id}>
                  <td className="px-4 py-3 text-xs text-slate-600 dark:text-slate-400 font-mono-tech whitespace-nowrap">{new Date(h.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3 font-medium">{prettify(h.action_taken)}</td>
                  <td className="px-4 py-3 text-xs font-mono-tech text-cyan-300">{h.package_id || "—"}</td>
                  <td className="px-4 py-3 text-xs font-mono-tech text-sky-300">{h.batch_code || "—"}</td>
                  <td className="px-4 py-3 text-xs text-slate-700 dark:text-slate-300">{h.status_before ? prettify(h.status_before) : "—"} → {h.status_after ? prettify(h.status_after) : "—"}</td>
                  <td className="px-4 py-3 text-xs text-slate-600 dark:text-slate-400">{h.updated_by_name || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
       )}
    </div>
  );
}
function prettify(s) { return (s || "").replace(/_/g, " ").toLowerCase().replace(/\b\w/g, c => c.toUpperCase()); }
